import React from 'react'
import { Card, Col, Row, Input } from "antd";
import Title from "antd/es/typography/Title";
import BusinessesTable from "../components/Businesses/EnrolledBusinessesTable";
import { SearchOutlined } from "@ant-design/icons";
import { useEffect, useState } from "react";
import { connect } from "react-redux";
import { getAllBusiness } from "../store/action/admin/BusinessAdminAction";
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Box from '@mui/material/Box';

const Businesses = (props) => {
    const [businesses, setBusinesses] = useState([]);
    const [searchTerm, setSearchTerm] = useState(""); // Search state
    const [value, setValue] = React.useState('one'); // Track the selected tab
        
    const handleChange = (event, newValue) => {
     setValue(newValue); // Update the selected tab
    };
    

    useEffect(() => {
        props.getAllBusiness_();
    }, []);

    useEffect(() => {
        if (props.businessList?.businesses?.length > 0) {
            setBusinesses(props.businessList.businesses);
        }
    }, [props.businessList]);

    // Function to check if any field contains the search term
    const matchesSearch = (business) => {
        const term = searchTerm.toLowerCase();
        return Object.values(business).some(value => 
            value?.toString().toLowerCase().includes(term)
        );
    };

    // Filter businesses based on search term
    const filteredBusinesses = businesses.filter(matchesSearch);

    return (
        <div style={{ padding: 20 }}>
            <Title level={3}>Enrolled Businesses based on the domain</Title>
            <Tabs value={value} onChange={handleChange} textColor="primary" indicatorColor="primary" aria-label="primary tabs example">
                <Tab value="one" label="Movers" />
                <Tab value="two" label="Health Care" />
                <Tab value="three" label="Financial Service" />
                <Tab value="four" label="Manufacturing" />
                <Tab value="five" label="Real Estate" />
                <Tab value="six" label="E-Commerce" />
            </Tabs>
                {value == 'one' && (
                           <Row gutter={20} style={{ marginTop: 20 }}>
                           <Col span={24}>
                               <Card extra={
                                   <Input
                                       placeholder="Search anything..."
                                       prefix={<SearchOutlined style={{ color: "#888" }} />}
                                       style={{ borderRadius: "5px", padding: "8px 12px" }}
                                       value={searchTerm}
                                       onChange={(e) => setSearchTerm(e.target.value)} 
                                   />
                               } style={{ height: '100%' }}>
                                   <BusinessesTable data={filteredBusinesses} mini={false} expand={true} />
                               </Card>
                           </Col>
                       </Row>
                      )}
         {value === 'two' && (
        <Box sx={{p:5}}>
            <h3 style={{textAlign:'center', marginTop:'20px'}}>The Health Care Business table is set to start</h3>
        </Box>
      )}
      {value === 'three' && (
        <Box sx={{p:5}}>
          <h3 style={{textAlign:'center', marginTop:'20px'}}>The Financial Service Business table is set to start</h3>
      </Box>
      )}
      {value === 'four' && (
        <Box sx={{p:5}}>
           <h3 style={{textAlign:'center', marginTop:'20px'}}>The Manufacturing Business table is set to start</h3>
       </Box>
      )}
      {value === 'five' && (
        <Box sx={{p:5}}>
           <h3 style={{textAlign:'center', marginTop:'20px'}}>The Real Estate Business table is set to start</h3>
       </Box>
      )}
      {value === 'six' && (
        <Box sx={{p:5}}>
           <h3 style={{textAlign:'center', marginTop:'20px'}}>The E-Commerce Business table is set to start</h3>
       </Box>
      )}  
        </div>
    );
}

const mapStateToProps = state => ({
    businessCard: state.businesscard.response,
    thisWeekLeadBusiness: state.thisWeekLeadBusiness.response,
    businessList: state.businessList.response,
});

const mapDispatchToProps = dispatch => ({
    getAllBusiness_: () => {
        dispatch(getAllBusiness());
    },
});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(Businesses);







// import { Card, Col, Row, Input } from "antd";
// import Title from "antd/es/typography/Title";
// import LeadsTable from "../components/Leads/LeadsTable";
// import { SearchOutlined } from "@ant-design/icons";
// import BusinessesTable from "../components/Businesses/EnrolledBusinessesTable";
// import { useEffect, useState } from "react";
// import { connect } from "react-redux";
// import { getAllBusiness } from "../store/action/admin/BusinessAdminAction";


// const Businesses = (props) => {

//     const [businesses, setBusinesses] = useState([]);

//     useEffect(() => {
//         props.getAllBusiness_();
//     }, []);

//     useEffect(() => {
//         console.log(props.businessList);
//         if (props.businessList && props.businessList.businesses && props.businessList.businesses.length > 0) {
//             setBusinesses(props.businessList.businesses);
//         }
//     }, [props.businessList]);
//     return (
//         <div style={{ padding: 20 }}>
//             <Title level={2}>Enrolled Businesses</Title>
//             <Row gutter={20} style={{ marginTop: 20 }}>
//                 <Col span={24}>
//                     <Card extra={<>
//                         <Input
//                             placeholder="Search business..."
//                             prefix={<SearchOutlined style={{ color: "#888" }} />}
//                             style={{ borderRadius: "5px", padding: "8px 12px" }} />
//                         </>
//                         }style={{ height: '100%' }}>
//                         <BusinessesTable data={businesses} mini={false} expand={true} />
//                     </Card>
//                 </Col>
//             </Row>
//         </div>
//     );
// }
// const mapStateToProps = state => ({
//   businessCard: state.businesscard.response,
//   thisWeekLeadBusiness: state.thisWeekLeadBusiness.response,
//   businessList: state.businessList.response,
// })

// const mapDispatchToProps = dispatch => ({
//   getAllBusiness_: ()=>{
//       dispatch(getAllBusiness());
//   },
// }) 

// export default connect(
//   mapStateToProps,
//   mapDispatchToProps
// )(Businesses);